<template>
  <form class="modal__form" @submit.prevent="">
    <header class="modal__header">
      <h2>Create an account</h2>

      <div class="img" @click="$emit('close')">
        <img :src="mediaBaseUrl + 'close.svg'" alt="close">
      </div>
    </header>

    <div class="fields">
      <label v-for="field in formFields" :key="field.name" :class="[{field_error: field.error}]">
        <span>{{field.name}}</span>
        <input v-model="field.value" :type="field.name === 'Password' ? passwordType : field.type" required>
        <span v-show="field.error" class="error">{{field.errorMessage}}</span>

        <span v-show="field.name === 'Password'" class="show-password">
          <img v-show="!showPassword" class="show_off" :src="mediaBaseUrl + 'eye.svg'" alt="eye" @click="showPassword = true">
          <img v-show="showPassword" class="show_on" :src="mediaBaseUrl + 'eye_off.svg'" alt="eye off" @click="showPassword = false">
        </span>
      </label>
    </div>

    <custom-button @click="submitForm">
      Sign In
    </custom-button>

    <footer class="modal__footer">
      <a @click.prevent="$emit('changeModal', 'login')">Already a member? Sign in here</a>
    </footer>
  </form>
</template>

<script>
export default {
  name: "Register",
  inject: ["mediaBaseUrl"],

  data() {
    return {
      showPassword: false,
      formFields: [
        {
          name: "First name",
          type: "text",
          value: "",
          error: false,
          errorMessage: "First name entered incorrectly",
          validate() {
            return this.value.length > 0;
          },
        },
        {
          name: "Last name",
          type: "text",
          value: "",
          error: false,
          errorMessage: "Last name entered incorrectly",
          validate() {
            return this.value.length > 0;
          },
        },
        {
          name: "E-mail",
          type: "email",
          value: "",
          error: false,
          errorMessage: "E-mail address entered incorrectly",
          validate() {
            return this.value.length > 0;
          },
        },
        {
          name: "Password",
          type: this.passwordType,
          value: "",
          error: false,
          errorMessage: "Password entered incorrectly",
          validate() {
            return this.value.length > 0;
          },
        },
      ],
    };
  },

  computed: {
    passwordType() {
      return this.showPassword ? 'text' : 'password';
    },
  },

  methods: {
    submitForm() {
      let errors = false;
      for (const field of this.formFields) {
        field.error = !field.validate();
        errors = errors || field.error;
      }

      if (!errors) {
        this.$emit('action', {
          'firstName': this.formFields[0].value,
          'lastName': this.formFields[1].value,
          'email': this.formFields[2].value,
          'password': this.formFields[3].value,
        });
      }
    },
  },
}
</script>
